export default class availabilityPanel {
    constructor() {
        return {
            restrict: 'E',
            scope: {},
            template: require('../../../../views/availability/panel.html'),
            controller: PanelCtrl,
            controllerAs: 'panel'
        }
    }
}

class PanelCtrl {
    constructor($scope, $timeout, $location, $q, Browser, Events, $filter, $translate) {
        this._scope = $scope;
        this._location = $location;
        this._filter = $filter;
        this._translator = $filter('translate');
        this.translate = $translate;
        this._q = $q;
        this._timeout = $timeout;

        this.browserRepo = Browser;
        this.eventHandler = Events;
        
        this.originalParagraphHtml = [];
        this.settingsLoaded = false;

        this.fonts = [
            { name: 'Arial', value: "Arial,'Helvetica Neue',Helvetica,sans-serif" },
            { name: 'Trebuchet', value: "'Trebuchet MS','Lucida Grande','Lucida Sans Unicode','Lucida Sans',Tahoma,sans-serif" },
            { name: 'Calibri', value: "Calibri,Candara,Segoe,'Segoe UI',Optima,Arial,sans-serif" },
            { name: 'Times', value: "TimesNewRoman,'Times New Roman',Times,Baskerville,Georgia,serif" },
            { name: 'Dyslexi-typsnitt', value: 'open-dyslexic' },
            { name: 'Courier New', value: "'Courier New',Courier,'Lucida Sans Typewriter','Lucida Typewriter',monospace" }
        ];

        this._scope.$emit('browser:getContentTables');

        this.getPreferences().then(() => {
            this._timeout(() => {
                this.settingsLoaded = true;
            }, 500);
        });
    }

    onColorChange() {
        this._scope.$emit('browser:panel:colorChanged', this.settings.font_color);
    }

    onBackgroundColorChange() {
        this._scope.$emit('browser:panel:backgroundColorChanged', this.settings.background_color);
    }
    
    onImageSettingsChanged() {
        this._scope.$emit('browser:panel:imageSettingsChanged', this.settings.show_images);
    }
    
    onParagraphLengthChange() {
        this._scope.$emit('browser:panel:paragraphLengthChanged', this.settings.less);
    }

    setFontSize(newSize) {
        if (newSize <= 300 && newSize >= 40) {
            this.settings.font_size = newSize;
            this._scope.$emit('browser:panel:setFontSize', newSize);
        }
    };

    formatFontSize(inc) {
        var newSize = inc ? parseInt(this.settings.font_size) + 20 : parseInt(this.settings.font_size) - 20;
        this.setFontSize(newSize);
    };

    setLineHeight(newHeight) {
        if (newHeight <= 5 && newHeight >= 0.8) {
            this.settings.line_height = newHeight;
            this._scope.$emit('browser:panel:applyLineHeight', newHeight);
        }
    };

    formatLineHeight(inc) {
        let newHeight = inc ? parseFloat(this.settings.line_height) + 0.2 : parseFloat(this.settings.line_height) - 0.2;
        this.setLineHeight(newHeight.toFixed(1));
    };

    validLineHeight(inc) {
        let newHeight = inc ? parseFloat(this.settings.line_height) + 0.2 : parseFloat(this.settings.line_height) - 0.2;
        newHeight = newHeight.toFixed(1);

        if (inc && newHeight <= 5 || ! inc && newHeight >= 0.8) {
            this.settings.line_height = newHeight;
        }
    };

    setFont(font) {
        this.selectedFont = font;
        this.settings.font_family = font.value;
        this._scope.$emit('browser:panel:fontChanged', font);
    };

    getEncryption() {
        let url = this._location.absUrl();
        let start = url.indexOf('browser/');
        return url.substring(start + 8, url.length-1).replace(/\//g, '__SLASH__');
    };

    original() {
        if (! this.settings) {
            this.settings = {};
        }

        this.settings = {
            font_size: 100,
            font_family: "Arial,'Helvetica Neue',Helvetica,sans-serif",
            line_height: 1.2,
            background_color: '#ffffff',
            font_color: '#000000',
            less: false,
            show_synonyms: false,
            show_images: true
        };

        this.selectedFont = this.fonts[0];
        this._scope.$emit('browser:panel:fontChanged', this.selectedFont);
        this._scope.$emit('browser:panel:applyLineHeight', this.settings.line_height);
        this._scope.$emit('browser:panel:setFontSize', this.settings.font_size);
        this._scope.$emit('browser:panel:colorChanged', this.settings.font_color);
        this._scope.$emit('browser:panel:backgroundColorChanged', this.settings.background_color);
    };

    init() {
        this.settings = {
            font_size: 100,
            line_height: 1.2,
            background_color: '#ffffff',
            font_color: '#000000',
            less: false,
            show_images: true,
            show_synonyms: false
        };

        this.selectedFont = this.fonts[0];
    };

    save() {
        if (! this.hasSavedSettings) {
            this.settings.font = this.settings.font_family ? this.settings.font_family : this.selectedFont.value;

            this.browserRepo.createPreferences(this.settings, this.selectedFont.value, this.getEncryption()).then((settings) => {
                this.settings = settings;
                this.eventHandler.flashEvent('notification', this._translator('BROWSER:VIEW:ADJUSTMENTS_SAVED'));
            });
        } else {
            this.browserRepo.updatePreferences(this.settings).then(() => {
                this.eventHandler.flashEvent('notification', this._translator('BROWSER:VIEW:ADJUSTMENTS_UPDATED'));
            });
        }
    };

    getPreferences() {
        var deferred = this._q.defer();

        this.browserRepo.getPreferences(this.getEncryption()).then((response) => {
            if (typeof response === 'object') { // Preferences has been saved
                this.translate.use(response.language);
                this.hasSavedSettings = true;
                response.line_height = parseFloat(response.line_height).toFixed(1);
                response.less = response.less != 0;
                response.show_images = response.show_images != 0;
                this.settings = response;

                if (this.settings.font_size != 100) {
                    this._scope.$emit('browser:panel:setFontSize', this.settings.font_size);
                }

                this._scope.$emit('browser:panel:applyLineHeight', this.settings.line_height);
                this._scope.$emit('browser:panel:colorChanged', this.settings.font_color);
                this._scope.$emit('browser:panel:backgroundColorChanged', this.settings.background_color);

                angular.forEach(this.fonts, (font) => {
                    if (font.value == this.settings.font_family) {
                        this.selectedFont = font;
                        this._scope.$emit('browser:panel:fontChanged', font);
                        deferred.resolve();
                    }
                });
            } else { // No preferences stored
                this.translate.use(response);
                this.init();
                this.hasSavedSettings = false;
                deferred.resolve();
            }
        });

        return deferred.promise;
    };
}
